// extracted by mini-css-extract-plugin
export default {"theme":"f6pWR","theme_theme_light":"Cr8I5","theme_theme_dark":"TMvT5"};